import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormsModule } from '@angular/forms';
import { Routes, RouterModule } from '@angular/router';
import { FontAwesomeModule } from '@fortawesome/angular-fontawesome';
import { IonicModule } from '@ionic/angular/lazy';
import { SelectEventSessionTicketTypePage } from 'src/app/modals/select-event-session-ticket-type/select-event-session-ticket-type.page';

const routes: Routes = [
  {
    path: '',
    component: SelectEventSessionTicketTypePage
  }
];

@NgModule({
  imports: [
    CommonModule,
    FormsModule,
    IonicModule,
    FontAwesomeModule,
    RouterModule.forChild(routes)
  ],
  declarations: [SelectEventSessionTicketTypePage]
})
export class SelectEventSessionTicketTypePageModule {}
